import { AppThunkAction } from '../../../index'
import { NEW_USER_ACTION_TYPES } from './reducers'


export const setNewUserRoles = (roles: string[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: NEW_USER_ACTION_TYPES.SET_NEW_USER_ROLES,
			payload: roles,
		})
	}
}

export const clearNewUserRoles = (): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: NEW_USER_ACTION_TYPES.CLEAR_NEW_USER_ROLES
		})
	}
}
export const setNewAva = (ava: string): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: NEW_USER_ACTION_TYPES.SET_NEW_USER_AVA,
			payload: ava,
		})
	}
}
export const setNewCv = (cv: string): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: NEW_USER_ACTION_TYPES.SET_NEW_USER_CV,
			payload: cv,
		})
	}
}
